const WORKSPACE_DASHBOARD_ROUTE_REGEX = /^\/([^/]+)_(\d+)(?:\/project_(\d+))?\/dashboard/;

export const parseWorkspaceRoute = (pathname) => {
  const match = pathname.match(WORKSPACE_DASHBOARD_ROUTE_REGEX);
  if (!match) return null;

  return {
    workspacePrefix: match[1],
    workspaceId: parseInt(match[2], 10),
    projectId: match[3] ? parseInt(match[3], 10) : null,
  };
};

export const getWorkspaceIdFromPath = (pathname) =>
  parseWorkspaceRoute(pathname)?.workspaceId ?? null;

export const getProjectIdFromPath = (pathname) =>
  parseWorkspaceRoute(pathname)?.projectId ?? null;

export const isWorkspaceDashboardRoute = (pathname) =>
  WORKSPACE_DASHBOARD_ROUTE_REGEX.test(pathname);

export const isWorkspaceDashboardHome = (pathname) =>
  pathname === '/dashboard' ||
  pathname === '/' ||
  /^\/[^/]+_\d+(?:\/project_\d+)?\/dashboard\/?$/.test(pathname) ||
  /^\/[^/]+_\d+(?:\/project_\d+)?\/dashboard\/overview\/?$/.test(pathname);

export const buildWorkspaceDashboardPath = (workspaceId, projectId = null, subPath = '') => {
  const base = `/workspace_${workspaceId}`;
  const dashboardPath = projectId
    ? `${base}/project_${projectId}/dashboard`
    : `${base}/dashboard`;

  return subPath ? `${dashboardPath}/${subPath}` : dashboardPath;
};
